import React, { useCallback } from 'react';

import './infiniteScrollStyles.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
  onBottomThreshold?: () => void;
  onTopThreshold?: () => void;
};

const InfiniteScroll = ({ children, className, onBottomThreshold, onTopThreshold }: Props) => {
  const onScrollEvent = useCallback(
    (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
      if (
        onBottomThreshold &&
        (event.target as HTMLElement).scrollTop + (event.target as HTMLElement).clientHeight >=
          (event.target as HTMLElement).scrollHeight
      ) {
        onBottomThreshold();
      }

      if (onTopThreshold && (event.target as HTMLElement).scrollTop === 0) {
        onTopThreshold();
      }
    },
    [onBottomThreshold, onTopThreshold]
  );

  return (
    <div className={`c-InfiniteScroll ${className}`} onScroll={(e) => onScrollEvent(e)}>
      {children}
    </div>
  );
};

export default InfiniteScroll;
